import Card from './Card';

const Featured = (props) => {
  const { agent, index, onButtonClick, playingIndex, setPlayingIndex, utmParams, ...rest } = props;
  return (
    <Card
      bg="tan"
      index={index}
      agent={agent}
      video={true}
      playingIndex={playingIndex}
      setPlayingIndex={setPlayingIndex}
      onButtonClick={onButtonClick}
      {...rest}
    />
  );
};

export default Featured;
